import { render, staticRenderFns } from "./SiteOwnershipPopup.vue?vue&type=template&id=2ec3b2a7"
import script from "./SiteOwnershipPopup.vue?vue&type=script&lang=js"
export * from "./SiteOwnershipPopup.vue?vue&type=script&lang=js"
import style0 from "./SiteOwnershipPopup.vue?vue&type=style&index=0&id=2ec3b2a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports